export class Series {
    X: any;
    Y: any;
}